export default {
  userinfo: function userinfo(state) {
    return state.d2admin.user.info;
  },
  // 用户角色id
  roleId: function roleId(state) {
    return state.d2admin.user.userInfo.ROLE_ID || 0;
  },
  // 路由
  roleMenu: function roleMenu(state) {
    return state.d2admin.router.routerMenu || [];
  },
  // 送货单操作状态
  $MaintainDeliveryNote2State: function $MaintainDeliveryNote2State(state) {
    return state.DeliveryNote.MaintainDeliveryNote2.orderStatu || 'listShow';
  },
  // 委外送货单操作状态
  $OutsourcedState: function $OutsourcedState(state) {
    return state.DeliveryNote.Outsourced.orderStatu || 'listShow';
  },
  // 获取当前路由路径
  routerPath: function routerPath(state) {
    return state.custom.routerInfo.routerPath;
  },
  // 内箱标签订单状态
  $DeliveryCodeOrderState: function $DeliveryCodeOrderState(state) {
    return state.DeliveryNote.DeliveryCode.orderStatu || 'listShow';
  },
  // 外箱标签订单状态
  $OuterBoxLabelManagementOrderState: function $OuterBoxLabelManagementOrderState(state) {
    return state.DeliveryNote.OuterBoxLabelManagement.orderStatu || 'listShow';
  },
  // 公告订单状态
  AnnouncementState: function AnnouncementState(state) {
    return state.Portal.Announcement.orderStatu || 'listShow';
  },
  // 手工打码内箱状态
  $DnbarcodeHandmadeState: function $DnbarcodeHandmadeState(state) {
    return state.DeliveryNote.DnbarcodeHandmade.orderStatu || 'listShow';
  },
  // 手工打码外箱状态
  $DnbarcodeHandmadeOutBoxState: function $DnbarcodeHandmadeOutBoxState(state) {
    return state.DeliveryNote.DnbarcodeHandmadeOutBox.orderStatu || 'listShow';
  },
  // 下游送货单状态
  $SubDeliveryNoteState: function $SubDeliveryNoteState(state) {
    return state.DeliveryNote.SubDeliveryNote.orderStatu || 'listShow';
  },
  // 未读下载任务数
  $UnreadExportMessionNum: function $UnreadExportMessionNum(state) {
    return state.d2admin.user.unreadExportMessionNum || null;
  },
  // 获取主业务API地址
  getVUE_APP_API: function getVUE_APP_API(state) {
    return state.custom.apiConfig.VUE_APP_API;
  },
  // 获取打印地址
  getVUE_APP_PRINT_TPL: function getVUE_APP_PRINT_TPL(state) {
    return state.custom.apiConfig.VUE_APP_PRINT_TPL;
  },
  // 获取列表下载地址
  getVUE_APP_DOWN: function getVUE_APP_DOWN(state) {
    return state.custom.apiConfig.VUE_APP_DOWN;
  },
  getVUE_APP_IWMS_API: function getVUE_APP_IWMS_API(state) {
    return state.custom.apiConfig.VUE_APP_IWMS_API;
  },
  // 用户中心通用导出EXCEL 基地址
  getVUE_APP_FILE_PATH: function getVUE_APP_FILE_PATH(state) {
    return state.custom.apiConfig.VUE_APP_FILE_PATH;
  }
};